/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P4_TInputs */

const en_mk_sec_pg_p4_t = /** @type {(inputs: Mk_Sec_Pg_P4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything that matters leaves a trail`)
};

const id_mk_sec_pg_p4_t = /** @type {(inputs: Mk_Sec_Pg_P4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang penting meninggalkan jejak`)
};

/**
* | output |
* | --- |
* | "Anything that matters leaves a trail" |
*
* @param {Mk_Sec_Pg_P4_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p4_t = /** @type {((inputs?: Mk_Sec_Pg_P4_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P4_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p4_t(inputs)
	return en_mk_sec_pg_p4_t(inputs)
});